import { createFileRoute } from "@tanstack/react-router";
import LearnConnectBarcelona from "@/pages/LearnConnectBarcelona";

const TITLE = "QbD Learn & Connect 2026 - Barcelona";
const DESCRIPTION =
  "QbD Learn & Connect 2026 es un encuentro diseñado para reunir a profesionales clave del sector pharma, biotech y medical devices en España y generar conversación en torno a los principales retos e insights de la industria.";

export const Route = createFileRoute("/es/learn-connect-2026-barcelona")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: LearnConnectBarcelona,
});
